// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tJ9EW","label":"styles_label__PptVt"};